import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import { ThemeConsumer } from 'styled-components'

const LogoComponent = () => {
  const data = useStaticQuery(graphql`
    query {
      light: file(relativePath: { eq: "logo@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 144, quality: 100, layout: FIXED)
        }
      }
      dark: file(relativePath: { eq: "logo-dark@2x.png" }) {
        childImageSharp {
          gatsbyImageData(width: 144, quality: 100, layout: FIXED)
        }
      }
    }
  `)

  return (
    <ThemeConsumer>
      {theme => (
        <GatsbyImage
          image={getImage(
            theme.appearance === 'light'
              ? data.light.childImageSharp
              : data.dark.childImageSharp
          )}
          alt="IconJar logo"
        />
      )}
    </ThemeConsumer>
  )
}

export default LogoComponent
